module.exports = __webpack_public_path__ + "img/hammer.4e5d6b07.svg";